// pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TickerSearch from './TickerSearch'; // Add this import
import '../css/Home.css';

const Home = () => {
  const { user } = useAuth();
  console.info("Current User in Home page: ", user);
  return (
    <div className="home-container">
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Welcome to Naga's Smart Portfolio
          </h1>
          <p className="hero-subtitle">
            Advanced portfolio management with real-time analytics, risk assessment, 
            and intelligent trading insights.
          </p>
          
          {!user ? (
            <div className="hero-actions">
              <Link to="/registration" className="cta-button primary">
                Get Started
              </Link>
              <Link to="/portfolio" className="cta-button secondary">
                View Demo
              </Link>
            </div>
          ) : (
            <div className="hero-actions">
              <Link to="/portfolio" className="cta-button primary">
                Go to Portfolio
              </Link>
              <Link to="/prediction/SMCI" className="cta-button secondary">
                View Predictions
              </Link>
              <Link to="/Search" className="cta-button secondary">
                View Stock Analysis
              </Link>      
              <Link to="/tradeOperation" className="cta-button secondary">
                Trade Operation
              </Link>  
            </div>
          )}
        </div>
        
        <TickerSearch />
        {/* <div className="hero-visual">
          <div className="chart-placeholder">
            📈 Live Portfolio Analytics
          </div>
        </div> */}
      </section>

      <section className="features-section">
        <h2 className="features-title">Why Choose Naga's Smart Portfolio?</h2>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3>Real-time Analytics</h3>
            <p>Live portfolio tracking with advanced analytical tools and visualization</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">📊</div>
            <h3>Risk Management</h3>
            <p>Comprehensive risk assessment with portfolio beta and volatility analysis</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Fast Execution</h3>
            <p>Quick trade execution with Tiger Trade integration</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🔒</div>
            <h3>Secure Storage</h3>
            <p>Encrypted storage of your trading keys and portfolio data</p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Transform Your Portfolio Management?</h2>
        <p>Join hundreds of smart investors using our platform</p>
        {!user && (
          <Link to="/registration" className="cta-button large">
            Start Your Journey Today
          </Link>
        )}
      </section>
    </div>
  );
};

export default Home;